import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className='footer-container'>
      <div class='footer-links'>
      </div>
      <span>Nossas redes sociais</span>
      <div>
      <a className='ins' href='https://www.instagram.com/artecrochenatal/'><img  src='images/instagran.png' alt='' width="30px" height="30px"></img></a>
      <a className='ins' href='https://api.whatsapp.com/send?phone=5584999096035&text=Ol%C3%A1%20seja%20bem%20vindo.%20Logo%20voc%C3%AA%20ser%C3%A1%20atendido.'><img  src='images/whatsapp.png' alt='' width="30px" height="30px"></img></a>
      </div>
         
        <div class='social-media-wrap'>
          
          <div class='footer-logo'>
          <small class='website-rights'>Arte Crochê Natal © 2023</small>
          </div>
          <div class='social-icons'>
          </div>
        </div>
    </div>
  );
}

export default Footer;
